import React, { FC } from "react";
import { SVGProps, setClass } from "@utils";

interface LoginLogoProps extends SVGProps {
  allClassName?: string;
}

export const LoginLogo: FC<LoginLogoProps> = ({
  onClick,
  divClassName,
  allClassName,
}) => (
  <div
    className={setClass(
      onClick && "clickable",
      "svg",
      divClassName,
      allClassName
    )}
    onClick={onClick}
  >
    <svg
      width="206"
      height="54"
      viewBox="0 0 206 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M159.094 14.5367L171.068 25.7242V28.9305H163.383L151.883 18.1702H147.726V28.9305H139.719V0.427232H147.726V11.1876H151.688L162.739 0.427232H170.281V3.6335L159.094 14.5353V14.5367ZM188.797 6.91254C193.766 6.91254 196.624 8.44492 197.805 10.9032H205.132V7.66053C202.415 2.74399 196.553 0 188.797 0C177.323 0 170.889 5.2373 170.889 14.6432C170.889 24.049 177.323 29.3577 188.797 29.3577C196.554 29.3577 202.415 26.5437 205.132 21.5557V18.3494H197.805C196.626 20.8791 193.729 22.4466 188.797 22.4466C182.505 22.4466 178.967 19.6325 178.967 14.6445C178.967 9.65653 182.505 6.91254 188.797 6.91254ZM41.9963 18.0273H58.6179V11.3291H41.9963V7.33843H62.1563V0.427232H33.9891V28.9305H62.7634V22.018H41.9963V18.0273ZM30.7372 10.5096C30.7372 16.7092 26.3766 20.6285 19.4416 20.6285H8.18257V28.9292H0.175341V0.427232H19.4416C26.3766 0.427232 30.7372 4.31006 30.7372 10.5096ZM22.6597 10.5096C22.6597 8.55004 21.2656 7.33843 19.0495 7.33843H8.18257V13.7159H19.0482C21.2643 13.7159 22.6583 12.4693 22.6583 10.5096H22.6597ZM118.345 0C110.588 0 104.726 2.74399 102.01 7.66053V10.9032H109.337C110.516 8.40988 113.376 6.8775 118.345 6.8775C123.314 6.8775 126.387 8.52039 127.614 11.5447H114.021V17.8157H127.595C126.355 20.836 123.156 22.4829 118.346 22.4829C113.537 22.4829 110.519 20.9155 109.338 18.3494H102.011V21.5557C104.728 26.5437 110.59 29.3577 118.346 29.3577C129.82 29.3577 136.254 24.0854 136.254 14.6432C136.254 5.20092 129.819 0 118.345 0ZM76.5956 0.427232L65.73 25.7229V28.9292H73.3438L82.4503 7.33843H83.6469L92.7534 28.9292H100.367V25.7229L89.5002 0.427232H76.5956Z"
        fill="#009CFF"
      />
      <path
        d="M110.286 51.6693V40.2768H113.365V43.999H117.418C120.322 43.999 121.905 45.3034 121.905 47.7037V47.9124C121.905 50.3301 120.305 51.6693 117.418 51.6693H110.286ZM113.365 49.0082H117.348C118.287 49.0082 118.774 48.6255 118.774 47.9124V47.7211C118.774 47.0254 118.27 46.6601 117.348 46.6601H113.365V49.0082Z"
        fill="#009CFF"
      />
      <path
        d="M96.5962 51.6867V40.2768H103.919C106.719 40.2768 108.406 41.7031 108.406 44.0338V44.2077C108.406 46.5558 106.719 47.982 103.919 47.982H99.6748V51.6867H96.5962ZM99.6748 45.3035H103.849C104.788 45.3035 105.275 44.9208 105.275 44.2077V44.0338C105.275 43.338 104.788 42.9554 103.849 42.9554H99.6748V45.3035Z"
        fill="#009CFF"
      />
      <path
        d="M90.3776 40.2768L95.2651 51.2171V51.6867H92.2213L91.3343 49.5822H86.012L85.1249 51.6867H82.0811V51.2171L86.9686 40.2768H90.3776ZM87.0904 46.9906H90.2559L88.6731 43.2163L87.0904 46.9906Z"
        fill="#009CFF"
      />
      <path
        d="M79.8516 48.9386H81.6083V54H78.5297V51.6867H70.181V54H67.1024V48.9386H68.546C69.0852 48.0863 69.4331 46.9906 69.4679 45.4426L69.5722 40.2768H79.8516V48.9386ZM72.303 45.46C72.2682 46.8862 72.0073 48.0342 71.4855 48.9386H76.773V43.025L72.3551 43.0424L72.303 45.46Z"
        fill="#009CFF"
      />
      <path
        d="M53.8778 51.6867V40.2768H56.9564V44.6077H62.5744V40.2768H65.6529V51.6867H62.5744V47.3558H56.9564V51.6867H53.8778Z"
        fill="#009CFF"
      />
      <path
        d="M41.3086 51.6867V40.2768H51.6749V42.938H44.3872V44.6599H51.327V47.2863H44.3872V49.0256H51.6749V51.6867H41.3086Z"
        fill="#009CFF"
      />
      <path
        d="M38.8397 40.2768V51.6867H35.7612V43.025L31.4129 43.0424L31.3259 46.8514C31.2563 50.0518 29.9171 51.6867 27.2733 51.6867H26.2645V48.9386H26.682C27.9864 48.9386 28.4734 48.3125 28.5082 46.6079L28.63 40.2768H38.8397Z"
        fill="#009CFF"
      />
      <path
        d="M21.128 40.2768L26.0154 51.2171V51.6867H22.9717L22.0846 49.5822H16.7623L15.8753 51.6867H12.8315V51.2171L17.7189 40.2768H21.128ZM17.8407 46.9906H21.0062L19.4235 43.2163L17.8407 46.9906Z"
        fill="#009CFF"
      />
      <path
        d="M12.0708 40.2768V40.7465L7.44424 45.7905L11.7925 51.2171V51.6867H8.27911L4.83528 47.3384H3.07858V51.6867H0V40.2768H3.07858V44.5729H4.69614L8.43565 40.2768H12.0708Z"
        fill="#009CFF"
      />
    </svg>
  </div>
);
